import { BMUserProfile, BMUserProfileFromJSON } from "../BMUserProfile";

export interface UserPermissions {
  can_access_accounts: boolean;
  can_access_sales: boolean;
  can_access_leads: boolean;
  can_access_invoices: boolean;
  can_access_members_information: boolean;
  can_access_audit: boolean;
  can_access_billing: boolean;
}

export function UserPermissionsFromJSON(json: any): UserPermissions {
  return {
    can_access_accounts: json["can_access_accounts"] ?? false,
    can_access_sales: json["can_access_sales"] ?? false,
    can_access_leads: json["can_access_leads"] ?? false,
    can_access_invoices: json["can_access_invoices"] ?? false,
    can_access_members_information:
      json["can_access_members_information"] ?? false,
    can_access_audit: json["can_access_audit"] ?? false,
    can_access_billing: json["can_access_billing"] ?? false,
  };
}

export interface CurrentUser {
  id: number;
  login: string;
  profile: BMUserProfile;
  permissions: UserPermissions;
}

export function CurrentUserFromJSON(json: any): CurrentUser {
  return {
    id: json["id"],
    login: json["login"],
    profile: BMUserProfileFromJSON(json["profile"] || {}),
    permissions: UserPermissionsFromJSON(json["permissions"] || {}),
  };
}
